var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99984 2.34473C5.3915 2.34473 1.6665 6.06973 1.6665 10.6781C1.6665 15.2864 5.3915 19.0114 9.99984 19.0114C14.6082 19.0114 18.3332 15.2864 18.3332 10.6781C18.3332 6.06973 14.6082 2.34473 9.99984 2.34473ZM14.1665 13.6697L12.9915 14.8447L9.99984 11.8531L7.00817 14.8447L5.83317 13.6697L8.82484 10.6781L5.83317 7.68639L7.00817 6.51139L9.99984 9.50306L12.9915 6.51139L14.1665 7.68639L11.1748 10.6781L14.1665 13.6697Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/Clear.2438f24b7700d715e311069c6be7fb0c.svg";
export { ForwardRef as ReactComponent };